/**
 *
 * Carousel Container
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const styles = () => ({
  root: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
    position: 'relative',
  },
});

function CarouselContainer(props) {
  const { classes, children } = props;
  return (
    <Grid item xs={12} className={classes.root}>
      {children}
    </Grid>
  );
}

CarouselContainer.propTypes = {
  classes: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default withStyles(styles)(CarouselContainer);
